import { DateTime } from "luxon";
import { SortByDirection, TaskItemsFilterByOption, TaskItemsSortByOption, TaskItemStatus } from "../../constants";
import { TaskItemDto } from "../../http";

export function filterTaskItemsFn(
  filterByOption: TaskItemsFilterByOption,
  filterByStatusOption: TaskItemStatus | undefined,
  item: TaskItemDto
) {
  switch (filterByOption) {
    case TaskItemsFilterByOption.Status: {
      if (filterByStatusOption) {
        return item.currentStatus === filterByStatusOption;
      } else {
        return false;
      }
    }
    case TaskItemsFilterByOption.All:
    default:
      return true;
  }
}

export function sortTaskItemsFn(
  sortByOption: TaskItemsSortByOption,
  sortByDirection: SortByDirection,
  a: TaskItemDto,
  b: TaskItemDto
) {
  switch (sortByOption) {
    case TaskItemsSortByOption.Name: {
      return sortByDirection === SortByDirection.Ascending
        ? b.description.localeCompare(a.description)
        : a.description.localeCompare(b.description);
    }
    case TaskItemsSortByOption.DateCreated: {
      const dateCreatedA = DateTime.fromISO(a.createdDateTimeUtc, { zone: "utc" }).toLocal().toMillis();
      const dateCreatedB = DateTime.fromISO(b.createdDateTimeUtc, { zone: "utc" }).toLocal().toMillis();

      return sortByDirection === SortByDirection.Ascending ? dateCreatedA - dateCreatedB : dateCreatedB - dateCreatedA;
    }
    case TaskItemsSortByOption.DateModified: {
      const dateModifiedA = DateTime.fromISO(a.lastModifiedDateTimeUtc, { zone: "utc" }).toLocal().toMillis();
      const dateModifiedB = DateTime.fromISO(b.lastModifiedDateTimeUtc, { zone: "utc" }).toLocal().toMillis();

      return sortByDirection === SortByDirection.Ascending
        ? dateModifiedA - dateModifiedB
        : dateModifiedB - dateModifiedA;
    }
    case TaskItemsSortByOption.Owner: {
      const ownersA = a.owners
        .map((x) => x.user.displayName)
        .sort((a, b) => a.localeCompare(b))
        .join(", ");

      const ownersB = b.owners
        .map((x) => x.user.displayName)
        .sort((a, b) => a.localeCompare(b))
        .join(", ");

      return sortByDirection === SortByDirection.Ascending
        ? ownersB.localeCompare(ownersA)
        : ownersA.localeCompare(ownersB);
    }
    default:
      return 0;
  }
}
